module.exports = __webpack_public_path__ + "static/img/tiaoz.b8e24d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiaoz.png
// module id = n08d
// module chunks = 4